/* eslint-disable max-len */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import PropTypes from 'prop-types';
import { Grid } from '@jutro/layout';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import MLEmployersAffiliationsAccordionBodyComponent from '../MLEmployersAffiliationsAccordionBodyComponent/MLEmployersAffiliationsAccordionBodyComponent';
import metadata from './MLEmployersAffiliationsAccordionComponent.metadata.json5';
import gatewayMetadata from './MLEmployersAffiliationsAccordionComponentGateway.metadata.json5';
import styles from './MLEmployersAffiliationsAccordionComponent.modules.scss';
import messages from './MLEmployersAffiliationsAccordionComponent.messages';


function MLEmployersAffiliationsAccordionComponent(props) {
    const {
        companies,
        gpcCode,
        selectOrganization,
        selectedPaypoint,
        quoteID,
        isGpa,
        sessionID,
        isEndorsement,
        searchText
    } = props;
    const translator = useTranslator();
    const isQnB = appConfig.portalCode === 'QB';

    const baseAccordionId = 'childAccordionCard';

    const [openAccordion, setOpenAccordion] = useState('');

    const formatStringToTitleCase = (str) => {
        return _.startCase(_.toLower(str));        
    }

    const formatMatchedNameWithBold = (name) => {
        const startIndexOfB = name.indexOf('<b>');
        if (startIndexOfB === -1) {
            return formatStringToTitleCase(name);
        }
        const endIndexOfB = name.indexOf('</b>');
        const stringBeforeBold = name.substring(0, startIndexOfB);
        const boldSubString = name.substring(startIndexOfB + 3, endIndexOfB);
        const stringWithoutBold = name.substring(endIndexOfB + 4);
        return (
            <>
                {stringBeforeBold}
                <strong>
                    {boldSubString}
                </strong>
                {`${  stringWithoutBold}`}
            </>
        );
    };

    const formatMatchedNameWithInverseBold = (name) => {
        if (!name) {
            return '';
        }

        const startIndexOfB = name.indexOf('<b>');

        if (startIndexOfB === -1) {
            return <strong>{formatStringToTitleCase(name)}</strong>;
        }

        const endIndexOfB = name.indexOf('</b>');

        if (endIndexOfB === -1) {
            return <strong>{formatStringToTitleCase(name)}</strong>;
        }

        const stringBeforeBold = name.substring(0, startIndexOfB);
        const matchedSubString = name.substring(startIndexOfB + 3, endIndexOfB);
        const stringAfterBold = name.substring(endIndexOfB + 4);

        return (
            <>
                <strong>
                    {stringBeforeBold}
                </strong>
                {matchedSubString}
                <strong>
                    {stringAfterBold}
                </strong>
            </>
        );
    };

    const getAccordionHeader = (isOpen, company) => {
        return (
            <>
                <Grid
                    columns={isQnB ? ['10fr', '1fr']:['6fr', '1fr', '5fr']}
                    phone={{
                        columns: ['5', '1']
                    }}
                >
                    <Grid
                        columns={isQnB? ['10', '1'] : ['1', '10'] }
                        className={isOpen ? 'vertical-spacing-10 remove-column-padding-mobile' : 'remove-column-padding-mobile'}
                    >
                        <div className={`subsection-header display-inline-block ${isQnB ? 'qnbHideAccordionIcon' : ''}`}>
                            <div className={isOpen ? 'icon-ml-carrot-down-outline icon-blue icon-rotate-180' : 'icon-ml-carrot-down-outline icon-blue display-block'} />
                        </div>
                        <p className={isOpen ? 'font-weight-bold truncate-mobile' : 'truncate-mobile'}>
                            {isQnB ? formatMatchedNameWithInverseBold(company.matchedName) : formatMatchedNameWithBold(company.matchedName)}
                        </p>
                    </Grid>
                    {!isQnB && (
                       <p className={isOpen ? 'font-weight-bold vertical-spacing-10' : ''}>
                        {company.gpcCode}
                    </p>
                    )}
                    {!isQnB && (
                        <p className={isOpen ? 'font-weight-bold vertical-spacing-10 hide-mobile' : 'hide-mobile truncate'}>
                            {company.companyName}
                        </p>
                    )}
                    
                    <div className={`subsection-header display-inline-block ${isQnB ? 'qnbAlignRight' : 'qnbHideAccordionIcon'}`}>
                        <div className={isOpen ? 'icon-ml-carrot-down-outline icon-blue icon-rotate-180' : 'icon-ml-right-carrot-icon icon-blue display-block'} />
                    </div>
                </Grid>
                {isOpen && !isQnB && (
                    <div className="vertical-spacing-10 show-mobile">
                        <p className="font-weight-bold">
                            {company.companyName}
                        </p>
                    </div>
                )}
            </>
        );
    };

    const getAccordionGatewayHeader = (isOpen, company) => {
        return (
            <>
                <Grid
                    columns={['5fr', '4fr', '1fr', '2fr']}
                    vgap= 'none'
                >
                    <Grid
                        columns={['1', '10']}
                        hgap='none'
                        className={isOpen ? 'vertical-spacing-10 remove-column-padding-mobile' : 'remove-column-padding-mobile'}
                    >
                        <div className="subsection-header display-inline-block">
                            <div className={isOpen ? 'icon-ml-carrot-down-outline icon-blue icon-rotate-180' : 'icon-ml-carrot-down-outline icon-blue display-block'} />
                        </div>
                        <p className={isOpen ? 'font-weight-bold' : ''}>
                            {formatMatchedNameWithBold(company.matchedName)}
                        </p>
                    </Grid>
                    <p className={isOpen ? 'font-weight-bold vertical-spacing-10' : ''}>
                        {company.companyName}
                    </p>
                    <p className={isOpen ? 'font-weight-bold vertical-spacing-10' : ''}>
                        {company.gpcCode}
                    </p>
                    {company.customerType && (
                        <p className={isOpen ? 'font-weight-bold vertical-spacing-10 text-capitalize' : 'text-capitalize'}>
                            {company.customerType === 'preferredemployer' ? translator(messages.preferredEmployer) : formatStringToTitleCase(company.customerType)}
                        </p>
                    )}                    

                </Grid>
                {isOpen && (
                    <div className="vertical-spacing-10">
                        <p>
                            {isGpa ? _.get(company, '.organizations[0].companyARSPrompt') : company.companyName}
                        </p>
                    </div>
                )}
            </>
        );
    };

    // Set to first element of open accordions - will only ever be one as closeOthers = true
    const updatedAccordionStates = (openAccordions) => {
        if (_.isEmpty(openAccordions)) {
            setOpenAccordion('');
        } else {
            setOpenAccordion(openAccordions[0]);
        }
    };

    const isCardActive = (index) => {
        return openAccordion === `${baseAccordionId}${index}companyAccordion`;
    };

    const generateAccordionOverrides = () => {
        const overrides = companies.map((company, index) => {
            return {
                [`childAccordionCard${index}`]: {
                    renderHeader: (isOpen) => {
                        return isGpa ? getAccordionGatewayHeader(isOpen, company) : getAccordionHeader(isOpen, company);
                    },
                    className: isCardActive(index) ? `ml-panel-set__heading display-block ml-section slim vertical-spacing-5 slim-blue cardBorder ${isQnB ? 'qnbPadding10' : ''}`
                        : `ml-panel-set__heading display-block ml-section slim vertical-spacing-5 cardBorder ${isQnB ? 'qnbPadding10' : ''}`
                },
                [`childAccordionBodyComponent${index}`]: {
                    index,
                    company,
                    isOpen: isCardActive(index),
                    selectOrganization,
                    selectedPaypoint,
                    quoteID,
                    isGpa,
                    sessionID,
                    isEndorsement,
                    searchText
                },
            };
        });

        return Object.assign({}, ...overrides);
    };


    const overrides = {
        tableHeaderRow: {
            visible: companies.length > 0
        },
        accountTypeCol: {
            visible: !!_.get(companies, '[0].customerType')
        },
        companyListContainerDiv: {
            visible: companies.length > 0
        },
        companyAccordion: {
            data: companies,
            onUpdateAccordionStates: updatedAccordionStates,
            closeOthers: true
        },
        employersaffiliationsaccordionbody: {
            searchText,
        },
        gpcCol: {
            visible: !isQnB
        },
        companyNameCol: {
            visible: !isQnB
        },
        matchedNameCol: {
            content: translator(isQnB ? messages.matchingResults : messages.matchedName)
        },
        companyCol: {
            className: isQnB ? 'col-md-6' : 'col-md-12'
        },
        parentAccordionContainer: {
            className: isQnB ? 'ml-employers-affiliations-accordion consumer slim vertical-spacing-20' : 'ml-employers-affiliations-accordion consumer ml-section slim vertical-spacing-20'
        },
        ...generateAccordionOverrides()
    };

    const resolvers = {
        resolveComponentMap: {
            employersaffiliationsaccordionbody: MLEmployersAffiliationsAccordionBodyComponent
        },
        resolveClassNameMap: styles
    };
    const metadataFile = isGpa ? gatewayMetadata : metadata;
    return (
        <MetadataContent
            uiProps={metadataFile.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLEmployersAffiliationsAccordionComponent.propTypes = {
    companies: PropTypes.arrayOf(PropTypes.shape({})),
    gpcCode: PropTypes.string,
    selectOrganization: PropTypes.func.isRequired,
    selectedPaypoint: PropTypes.shape({}),
    quoteID: PropTypes.string.isRequired,
    isGpa: PropTypes.bool.isRequired,
    sessionID: PropTypes.string.isRequired,
    isEndorsement: PropTypes.bool.isRequired,
    searchText: PropTypes.string
};

MLEmployersAffiliationsAccordionComponent.defaultProps = {
    companies: [],
    gpcCode: '',
    selectedPaypoint: {}
};


export default MLEmployersAffiliationsAccordionComponent;
